export default __webpack_public_path__ + "static/media/profit-journey-min.7d6ffff6.png";